/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { TagCriteria } from './TagCriteria';

export type TagCriteriaRequest = {
    name: string;
    description?: string | null;
    emoji?: string | null;
    type?: TagCriteriaRequest.type;
    isCriteriaBased: boolean;
    criteria: TagCriteria;
};

export namespace TagCriteriaRequest {

    export enum type {
        COMPOSITE = 'composite',
        COMPANY_JOB = 'companyJob',
    }


}

